<script>
import {getUserInfoApi,getBenefitsList} from "@/api/api";
import ATestLog from "@/pages/wx/components/ATestLog.vue";
import ABenefit from "@/pages/wx/components/ABenefit.vue";
import wx from "weixin-js-sdk";

export default {
  name: "MyBenefits",
  components: {ABenefit, ATestLog},
  metaInfo: {
    title: "权益",
  },
  data(){
    return {
      loaded:false,
      dataPage:[],
      userInfo:{},
      statusList: new Map([[0, '生成中'], [1, '生成中'], [2, '已生成'], [-2, '已删除'], [3, '未授权']]),
    }
  },

  async mounted() {
    this.loaded = false
    await this.loadUserInfoInfo()
    await this.loadBenefitsList()
    this.loaded = true
  },
  computed: {},
  methods:{
    handleBtnPurchaseClick(){
      wx.miniProgram.switchTab({ url: '/pages/index/Index' })
    },
    async loadUserInfoInfo() {
      const res = await getUserInfoApi(false)
      this.userInfo = res.data
    },
    async loadBenefitsList(){
      if (this.userInfo?.curOrgId==null){
        this.dataPage=[]
        return
      }
      let params = {
        organizationId: this.userInfo.curOrgId,
        spuListStr:'report,service'
      };
      const res = await getBenefitsList(params)
      this.dataPage= res.data
    }
  }
}
</script>

<template>
  <div>

    <div class="page-wrapper" v-if="loaded">
      <div class="empty-wrapper" v-if="dataPage==null||dataPage.length==0">
        <img src="@/assets/暂无数据.png" alt="" class="empty-img" />
        <div class="text">还没有购买过权益哦～</div>
        <div  class="btn-purchase" @click="handleBtnPurchaseClick">立即购买</div>
      </div>
      <div
        v-else
        class="detectionCard"
        v-for="(item, index) in dataPage"
        :key="index"
        :class="index == 0 ? 'topStyle' : ''"
      >
        <ABenefit :item="item"></ABenefit>
      </div>
    </div>
    <div v-else>
<!--      <div class="nullPic">-->
<!--        加载中...-->
<!--      </div>-->
    </div>

  </div>

</template>

<style scoped lang="stylus">
.page-wrapper{
  background #fff;
  min-height 100vh;
  padding-top .2rem
}
.detectionCard {
  //width: 7.10rem;
  //height: 2.68rem;
  background: #FFFFFF;
  border-radius: 14px 14px 14px 14px;
  padding:0 0.2rem;
  box-sizing: border-box;

}
.nullPic {
  display: flex;
  flex-direction: column;
  align-items: center
  margin-top: 3.2rem;
  font-size: 0.3rem
  img {
    width: 3.6rem;
    height: 3.6rem;
  }
}
  .empty-wrapper{
    min-height 100vh;
    display flex;
    align-items center;
    justify-content center;
    flex-direction column
    .empty-img{
      width 3.60rem
    }
    .btn-purchase{
      margin-top .8rem;
      width: 4rem;
      height: .8rem;
      border-radius: .10rem;
      background-color: #165DFF;
      color #fff;
      display flex;
      align-items center;
      justify-content center;
      font-size .3rem;
    }
  }

</style>
